<template>
  <div class="search-page-container">
    <div class="search-card">
      <h1 class="title">
        <span>Cari Hasil Tes</span>
        <svg xmlns="http://www.w3.org/2000/svg" class="title-icon" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
      </h1>
      <p class="subtitle">Ketik nama lengkap kamu, lalu klik tombol "Lihat Hasil" untuk melanjutkan.</p>

      <div class="autocomplete-wrapper">
        <div class="input-wrapper" :class="{ 'has-error': error, 'has-success': foundStudent }">
          <span class="input-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
          </span>
          <input
            type="text"
            v-model="searchQuery"
            placeholder="Ketik nama lengkap kamu..."
            @input="onInput"
            :disabled="isSearching"
          >
          <!-- [PERUBAHAN] Spinner sekarang juga aktif saat API sedang berjalan -->
          <div class="status-icon-container">
            <div v-if="isDebouncing || isSearching" class="debouncing-spinner"></div>
            <svg v-else-if="foundStudent" xmlns="http://www.w3.org/2000/svg" class="success-checkmark" viewBox="0 0 512 512"><path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l128-128z"/></svg>
            <svg v-else-if="error" xmlns="http://www.w3.org/2000/svg" class="error-cross" viewBox="0 0 512 512"><path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L222.1 256 141.1 337c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L256 289.9l81 81c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L289.9 256l81-81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L256 222.1 175 175z"/></svg>
          </div>
        </div>
        
        <!-- Menampilkan pesan error jika ada -->
        <div v-if="error" class="error-message-box">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="error-icon"><path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S500.9 480 488 480H24c-12.9 0-24.6-7.8-29.5-19.8s-7-27.7 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>
          <div class="error-text-content" v-html="error"></div>
        </div>
      </div>

      <!-- Area untuk menampilkan tombol hasil -->
      <div class="result-action-container">
        <button 
          @click="handleViewResult" 
          class="view-result-button"
          :disabled="!foundStudent"
        >
          <!-- Teks dibungkus span dan ikon ditambahkan -->
          <span>Lihat Hasil</span>
          <svg xmlns="http://www.w3.org/2000/svg" class="button-icon" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

// --- Props (Menerima data dari Induk) ---
const props = defineProps({
  error: {
    type: String,
    default: null
  },
  // [BARU] Prop untuk menandakan proses pencarian API di induk
  isSearching: {
    type: Boolean,
    default: false
  },
  // [BARU] Prop untuk menerima data siswa yang ditemukan dari induk
  foundStudent: {
    type: Object,
    default: null
  }
});

// --- Emits (Mengirim event ke Induk) ---
const emit = defineEmits(['search-by-name', 'clear-error', 'view-result']);

// --- State Internal Komponen ---
const searchQuery = ref('');
const debounceTimer = ref(null);
const isDebouncing = ref(false);

// --- Methods ---
const onInput = () => {
  if (props.error || props.foundStudent) {
    emit('clear-error'); // Membersihkan error dan hasil sebelumnya
  }

  clearTimeout(debounceTimer.value);
  isDebouncing.value = true;

  debounceTimer.value = setTimeout(() => {
    isDebouncing.value = false;
    // Hanya emit jika ada isi, untuk menghindari pencarian kosong
    if (searchQuery.value.trim()) {
      emit('search-by-name', searchQuery.value);
    }
  }, 2000); // 2 detik debounce
};

// [BARU] Method untuk memberitahu induk agar menampilkan hasil
const handleViewResult = () => {
  if (props.foundStudent && props.foundStudent.id) {
    emit('view-result', props.foundStudent.id);
  }
};
</script>

<style scoped>
/* Gaya CSS tetap sama, tidak perlu diubah */
.search-page-container {
  display: flex;
  flex-direction: column; /* Menumpuk elemen ke bawah */
  align-items: center; /* Memusatkan secara horizontal */
  justify-content: center;
  padding: 2rem 1rem;
  width: 100%;
}

.search-card {
  width: 100%;
  max-width: 600px;
  background: #fff;
  padding: 2.5rem;
  border-radius: 24px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.1);
  text-align: center;
}

.title {
  font-family: 'Epilogue', sans-serif;
  font-weight: 900;
  font-size: 1.4rem;
  color: #2c3e50;
  margin-bottom: 0.35rem;
}

.title-icon {
  width: 28px;
  height: 20px;
  fill: #333;
}

.subtitle {
  text-align: center;
  font-size: 0.8rem;
  color: #555;
  margin-bottom: 2rem;
}

.autocomplete-wrapper {
  position: relative;
  width: 100%;
  margin-bottom: 1.5rem;
}

.input-wrapper {
  position: relative;
}

.input-icon {
  position: absolute;
  top: 50%;
  left: 1rem;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  fill: #95a5a6;
}

.input-wrapper input {
  width: 100%;
  padding: 0.8rem 0.8rem 0.8rem 2.8rem;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  font-size: 0.9rem;
  font-family: 'Epilogue', sans-serif;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.input-wrapper input:focus {
  border-color: #3880d0;
  box-shadow: 0 0 0 3px rgba(56, 128, 208, 0.2);
  outline: none;
}

.suggestions-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 10px 10px;
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  text-align: left;
  box-shadow: 0 8px 16px rgba(0,0,0,0.1);
}

.suggestions-list li {
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.suggestions-list li:hover {
  background-color: #f0f0f0;
}

button {
  background-color: #FF6B6B;
  color: white;
  border: none;
  padding: 0.8rem 1.2rem;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

button:disabled {
  background-color: #bdc3c7;
  cursor: not-allowed;
}

.status-icon-container {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.debouncing-spinner {
  width: 20px;
  height: 20px;
  border: 3px solid rgba(0, 110, 175, 0.3);
  border-top-color: #006eaf;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* [BARU] Style untuk ikon centang hijau */
.success-checkmark {
  width: 24px;
  height: 24px;
  fill: #28a745;
  animation: checkmark-pop 0.4s ease-out;
}

.error-cross {
  width: 24px;
  height: 24px;
  fill: #ef4444;
  animation: checkmark-pop 0.4s ease-out;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* [BARU] Animasi untuk ikon centang */
@keyframes checkmark-pop {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  70% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}

.error-message-box {
  display: flex;
  align-items: flex-start; /* Align icon to the top */
  background-color: #fef2f2; /* Lighter red */
  color: #991b1b; /* Darker red text */
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 12px;
  font-size: 0.7rem;
  text-align: left;
  border-left: 5px solid #ef4444; /* Red accent border */
}

.error-icon {
  width: 20px;
  height: 20px;
  fill: #ef4444; /* Red icon */
  margin-right: 12px;
  flex-shrink: 0;
  margin-top: 1px; /* Small adjustment for vertical alignment */
}

.error-text-content {
  /* This will respect newline characters in the error string */
  white-space: pre-wrap;
  font-weight: 500;
  line-height: 1.4;
}

.input-wrapper.has-error {
  border-radius: 10px;
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.2);
}

.result-action-container {
  width: 100%;
  max-width: 600px; /* Lebar sama dengan card */
  margin-top: 1.5rem;
  height: 50px; /* Memberi ruang agar layout tidak "loncat" */
}

.view-result-button {
  width: 100%;
  padding: 12px 20px;
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
  background-color: #28a745;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease, box-shadow 0.3s ease;
  animation: pulse 2s infinite;
  /* [PERUBAHAN] Menambahkan flex untuk menata ikon dan teks */
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem; /* Jarak antara teks dan ikon */
}

.button-icon {
  width: 16px;
  height: 16px;
  fill: #ffffff;
  transition: transform 0.3s ease;
}

.view-result-button:hover:not(:disabled) .button-icon {
  transform: translateX(4px);
}

.view-result-button:hover:not(:disabled) {
  background-color: #218838;
  transform: translateY(-2px);
  animation-play-state: paused;
}

/* [PERUBAHAN] Menyempurnakan style disabled */
.view-result-button:disabled {
  background-color: #e2e8f0; /* Warna abu-abu lebih terang */
  color: #a0aec0; /* Warna teks lebih pudar */
  cursor: not-allowed;
  animation: none;
  box-shadow: none;
  transform: none;
}

/* [BARU] Mengubah warna ikon saat tombol disabled */
.view-result-button:disabled .button-icon {
  fill: #a0aec0;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}
</style>